/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import AllergyIcon from 'icons/AllergyIcon';

const messages = defineMessages({
  title: {id: 'navigation.health-allergens'},
});

const AllergensItem = () => (
  <RouteLinkItem
    iconBefore={AllergyIcon}
    route="midas/students/health/allergens"
    title={messages.title}
  />
);

export default AllergensItem;
